import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/Stores/auth-v2-store';
import { authApi } from '@/Api/auth-v2.api';
import { NewsArrival } from '@/features/news/components/reader/NewsArrival';
import { NewsUnreadBadge } from '@/features/news/components/reader/NewsUnreadBadge';
import { NEWS_FEED_PATH } from '@/features/news/constants/news.constants';

export default function Layout() {
  const { currentUser, hasPermission } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await authApi.logout();
    navigate('/login');
  };

  return (
    <div className="tw-h-screen tw-flex tw-flex-col tw-bg-gray-50 tw-overflow-hidden">
      {/* Header */}
      <header className="tw-bg-white tw-shadow-sm tw-border-b tw-border-gray-200">
        <div className="tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
          <div className="tw-flex tw-justify-between tw-items-center tw-h-16">
            {/* Logo / Title */}
            <div className="tw-flex tw-items-center tw-gap-6">
              <Link to="/dashboard" className="tw-flex tw-items-center tw-gap-2 tw-text-xl tw-font-bold tw-text-gray-900 hover:tw-text-gray-700">
                <svg className="tw-w-8 tw-h-8 tw-text-blue-600" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
                </svg>
                <span>Affinicar UpSell</span>
              </Link>
              <nav className="tw-hidden sm:tw-flex tw-items-center tw-gap-1">
                <Link
                  to="/dashboard"
                  className="tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-600 tw-rounded-md hover:tw-text-gray-900 hover:tw-bg-gray-100"
                >
                  Dashboard
                </Link>
                {hasPermission('upsell.appointments') && (
                  <Link
                    to="/rendez-vous"
                    className="tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-600 tw-rounded-md hover:tw-text-gray-900 hover:tw-bg-gray-100"
                  >
                    Rendez-vous
                  </Link>
                )}
                {hasPermission('upsell.dashboard') && (
                  <Link
                    to="/analytics"
                    className="tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-600 tw-rounded-md hover:tw-text-gray-900 hover:tw-bg-gray-100"
                  >
                    Performance
                  </Link>
                )}
                <Link
                  to={NEWS_FEED_PATH}
                  className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-600 tw-rounded-md hover:tw-text-gray-900 hover:tw-bg-gray-100"
                >
                  Nouveautés
                  <NewsUnreadBadge platform="UPSELL" />
                </Link>
                {/* La config des garanties reste dans l'admin */}
              </nav>
            </div>

            {/* User Menu */}
            <div className="tw-flex tw-items-center tw-gap-4">
              <span className="tw-text-sm tw-text-gray-600">
                {currentUser?.firstname} {currentUser?.lastname}
              </span>
              <button
                onClick={handleLogout}
                className="tw-inline-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded-md hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-blue-500"
              >
                <svg className="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                </svg>
                Déconnexion
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Nouveautés : bandeau + modale d'arrivée */}
      <NewsArrival platform="UPSELL" />

      {/* Main Content */}
      <main className="tw-flex-1 tw-min-h-0 tw-w-full tw-overflow-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-py-6">
        <Outlet />
      </main>
    </div>
  );
}
